module.exports = __webpack_public_path__ + "assets/images/tfg_y.273d1471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/tfg_y.png
// module id = 770
// module chunks = 1